import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const PRICE_BRL = "19,99";
export const PRICE_LABEL = `R$ ${PRICE_BRL}`;

export const KIWIFY_CHECKOUT_URL = "https://pay.cakto.com.br/3fhxpvm_1172429";

export function startCheckout() {
  window.location.href = KIWIFY_CHECKOUT_URL;
}
